/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { provideStore } from '@ngrx/store';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import localeFrExtra from '@angular/common/locales/extra/fr';
import { simpleModeReducer } from './app/core/states/reducers/simple-mode.reducer'; 

registerLocaleData(localeFr, 'fr', localeFrExtra);

// Always force light mode, ignore user/system preference
localStorage.setItem('dark-mode', 'false');
document.body.classList.remove('dark');

bootstrapApplication(AppComponent, {
  ...appConfig, 
  providers: [
    ...(appConfig.providers || []), 
    provideStore({ simpleMode: simpleModeReducer }),
  ],
}).catch((err) => console.error(err));